import type { ReactNode } from 'react';

export const symbol_hide_source: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m792-83-74-73q-50 36-110 56T480-80q-85 0-158-30.5T195-195q-54-54-84.5-127T80-480q0-68 20-128t56-110l-74-74q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l710 710q9 9 9 21t-9 21q-9 9-21.5 9T792-83Zm-312-57q55 0 104-15.5t91-43.5L199-675q-28 42-43.5 91T140-480q0 145 97.5 242.5T480-140Zm0-680q-45 0-86 10.5T317-780q-11 6-23 3.5T275-790q-7-11-4-22t14-17q43-24 92-37.5T480-880q84 0 157 31t127 85q54 54 85 127t31 157q0 57-13.5 107.5T827-277q-6 11-18 13.5t-23-4.5q-11-7-13-19.5t4-23.5q20-38 31.5-80t11.5-89q0-145-97.5-242.5T480-820Zm43 297Zm-86 86Z"
		/>
	</svg>
);
